import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import Services from '../components/sections/Services';
import LGTBIQASection from '../components/sections/LGTBIQASection';
import Methodology from '../components/sections/Methodology';
import Destinatarios from '../components/sections/Destinatarios';
import Contact from '../components/sections/Contact';
import ContactModal from '../components/ContactModal';

export default function ServiciosPage() {
  const [showContactModal, setShowContactModal] = useState(false);

  const openContactModal = () => setShowContactModal(true);
  const closeContactModal = () => setShowContactModal(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
          }
        });
      },
      { threshold: 0.1 }
    );
    document.querySelectorAll('.reveal').forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <>
      <Helmet>
        <title>Servicios | Inerva Psicología</title>
        <meta
          name="description"
          content="Servicios de psicología online: ansiedad, estrés, trauma, crisis vitales, procesos de identidad y acompañamiento afirmativo LGTBIQA+."
        />
        <link rel="canonical" href="https://www.inervapsicologia.es/servicios" />
      </Helmet>

      <Header />

      <main>
        <div className="reveal pt-32 lg:pt-40"><Services /></div>
        <div className="reveal"><LGTBIQASection /></div>
        <div className="reveal"><Methodology /></div>
        <div className="reveal"><Destinatarios /></div>
        <Contact onContactClick={openContactModal} />
      </main>

      <Footer />

      <ContactModal show={showContactModal} handleClose={closeContactModal} />
    </>
  );
}
